(() => {
  'use strict';

  const controllers = new WeakMap();
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  class FooterController {
    constructor(root) {
      if (controllers.has(root)) return controllers.get(root);
      this.root = root;
      this.abort = new AbortController();
      this.disclosures = [...root.querySelectorAll('[data-footer-disclosure]')];
      this.onMediaChange = this.syncDisclosures.bind(this);
      this.bind();
      this.syncDisclosures();
      controllers.set(root, this);
    }

    bind() {
      const signal = this.abort.signal;
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', this.onMediaChange, { signal });
      else mobileQuery.addListener(this.onMediaChange);

      this.root.addEventListener('toggle', (event) => {
        const details = event.target;
        if (!mobileQuery.matches || this.root.dataset.mobileAccordions !== 'true' || !details.matches('[data-footer-disclosure]') || !details.open) return;
        this.disclosures.forEach((item) => {
          if (item !== details) item.open = false;
        });
      }, { capture: true, signal });

      this.root.addEventListener('click', async (event) => {
        const copyButton = event.target.closest('[data-footer-copy]');
        if (copyButton) {
          event.preventDefault();
          await this.copy(copyButton.dataset.footerCopy || '');
          copyButton.classList.add('is-copied');
          window.setTimeout(() => copyButton.classList.remove('is-copied'), 1600);
          return;
        }

        const backToTop = event.target.closest('[data-footer-back-to-top]');
        if (backToTop) {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }, { signal });

      this.root.querySelectorAll('.footer-newsletter__form').forEach((form) => {
        form.addEventListener('submit', (event) => {
          if (!form.checkValidity()) return;
          const button = form.querySelector('button[type="submit"]');
          if (!button || button.disabled) {
            if (button?.disabled) event.preventDefault();
            return;
          }
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          const label = button.querySelector('span');
          if (label) label.textContent = button.dataset.sendingLabel || 'Enviando…';
        }, { signal });
      });
    }

    syncDisclosures() {
      const accordion = mobileQuery.matches && this.root.dataset.mobileAccordions === 'true';
      this.disclosures.forEach((details, index) => {
        if (accordion) details.open = this.root.dataset.firstPanelOpen === 'true' && index === 0;
        else details.open = true;
      });
    }

    async copy(value) {
      if (!value) return;
      try {
        await navigator.clipboard.writeText(value);
      } catch (_) {
        const input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      const toast = document.getElementById('Toast');
      if (toast) {
        toast.textContent = window.URBRAND?.strings?.linkCopied || 'Copiado.';
        toast.classList.add('show');
        window.setTimeout(() => toast.classList.remove('show'), 1800);
      }
    }

    destroy() {
      this.abort.abort();
      if (!mobileQuery.removeEventListener) mobileQuery.removeListener(this.onMediaChange);
      controllers.delete(this.root);
    }
  }

  const init = (scope = document) => scope.querySelectorAll('[data-footer-section]').forEach((root) => {
    if (!controllers.has(root)) new FooterController(root);
  });

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.('[data-footer-section]') || (event.target.matches?.('[data-footer-section]') ? event.target : null);
    if (root) controllers.get(root)?.destroy();
  });
})();
